import ServiceCreate from '_modules/service/views/ServiceCreate.vue';
import ServiceEdit from '_modules/service/views/ServiceEdit.vue';
import ServiceList from '_modules/service/views/ServiceList.vue';
import Service from './Root.vue';

export default {
  path: 'servicos/',
  component: Service,
  name: 'admin-service',
  redirect: '/servicos/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-service-list',
      component: ServiceList,
    },
    {
      path: 'novo/',
      name: 'admin-service-new',
      component: ServiceCreate,
    },
    {
      path: ':serviceId',
      name: 'admin-service-edit',
      component: ServiceEdit,
    },
  ],
};
